<template>
  <AnalyticsWidget
    :title="title"
    :subTitle="subTitle"
    :gridWidth="gridWidth"
    :gridHeight="gridHeight"
    :embedded="embedded">

    <div class="row no-gutter h-100">
      <div class="col-3" v-if="showList && hasChartData">
        <StaticDataTable class="static-table-list">
          <template v-slot:header>
            <tr>
              <th width="60%">{{recutValueTableData.nameTitle}}</th>
              <th width="40%">{{recutValueTableData.valueTitle}}</th>
            </tr>
          </template>
          <template v-slot:body>
            <tr v-for="(dataValue, index) of recutValueTableData.data" :key="index">
              <td>{{dataValue.name}}</td>
              <td><span v-html="dataValue.displayValue" /></td>
            </tr>
          </template>
        </StaticDataTable>
      </div>
      <div :class="showList ? 'col-9' : 'col-12'">
        <ChartDoughnut
          :series="recutValueSeries"
          :legend="recutValueLegend"
          :options="recutValueOptions"
        />
      </div>
    </div>
  </AnalyticsWidget>
</template>



<script>
import _ from 'lodash'
import moment from 'moment'

import Utils from '@/utils/utils'
import AnalyticsDateMixin from '@/modules/intelligence/mixins/analyticsDate'

import AnalyticsWidget from '@/modules/intelligence/components/analyticsWidget'
import ChartDoughnut from '@/components/charts/chartDoughnut'

import { ChartDateRangeTypes } from '@/modules/intelligence/types'

const RecutChartTypes = {
  breakdownValue: 'breakdownValue',
  breakdownCount: 'breakdownCount'
}

export default {
  name: 'RecutChartWidget',
  mixins: [AnalyticsDateMixin],
  components: {
    AnalyticsWidget,
    ChartDoughnut,
  },
  props: {
    title: String,
    subTitle: String,
    type: String,
    gridWidth: Number,
    gridHeight: Number,
    embedded: Boolean,
    showList: Boolean,
    dateRangeType: {
      type: String,
      default: ChartDateRangeTypes.today
    },
    startDate: String,
    endDate: String
  },
  RecutChartTypes: RecutChartTypes,
  data() {
    return {
      recutValueSeries: [],
      recutValueTableData: {},
      recutValueLegend: [],
      recutValueOptions: {}
    }
  },
  computed: {
    hasChartData() {
      if(this.recutValueSeries) {
        return this.recutValueSeries.some(series => {
          if(series.data && series.data.length > 0)
            return true
        })
      }
      return false
    }
  },
  mounted() {
    this.requestChartData()
  },
  watch: {
    dateRangeType: function() {
      this.requestChartData()
    },
    startDate: function() {
      this.requestChartData()
    },
    endDate: function() {
      this.requestChartData()
    }
  },
  methods: {
    requestChartData() {
      var filterData = {
        startDate: this.calculateStartDateForDateRangeType(this.dateRangeType, this.startDate).toDate().toISOString(),
        endDate: this.calculateEndDateForDateRangeType(this.dateRangeType, this.endDate).toDate().toISOString(),
        includeDetails: true
      }

      this.$apiService.analyticsService.getRecutValueSummary(filterData)
      .then(response => {
        var recutIssueList = response.data.recutIssueList

        this.recutValueOptions.tooltip = {
          formatter(param) {
            return `${param.seriesName} <br />${param.name} : ${Utils.formatCurrency(param.value)} (${param.percent}%)`
          }
        }

        if(this.type == RecutChartTypes.breakdownValue) {
          this.recutValueSeries = [{
            name: 'Recuts',
            data: recutIssueList.map(issueInfo => {
              return {
                name: issueInfo.labelName,
                value: issueInfo.totalPanelValue
              }
            }),
            label: {
              show: true,
              formatter(param) {
                return param.name
              }
            },
          }]
          this.recutValueLegend = {
            data: recutIssueList.map(issueInfo => issueInfo.labelName)
          }

          this.recutValueTableData = {
            nameTitle: 'Recut',
            valueTitle: 'Value',
            data: recutIssueList.map(issueInfo => {
              return {
                name: issueInfo.labelName,
                value: issueInfo.totalPanelValue,
                displayValue: Utils.formatCurrency(issueInfo.totalPanelValue)
              }
            })
          }

          this.recutValueTableData.data = _.sortBy(this.recutValueTableData.data, 'value').reverse()
        }

        if(this.type == RecutChartTypes.breakdownCount) {
          this.recutValueOptions.tooltip = {
            formatter(param) {
              return `${param.seriesName} <br />${param.name} : ${Utils.formatInteger(param.value)} (${param.percent}%)`
            }
          }
          
          this.recutValueSeries = [{
            name: 'Recuts',
            data: recutIssueList.map(issueInfo => {
              return {
                name: issueInfo.labelName,
                value: issueInfo.panelCount
              }
            }),
            label: {
              show: true,
              formatter(param) {
                return param.name
              }
            },
          }]
          this.recutValueLegend = {
            data: recutIssueList.map(issueInfo => issueInfo.labelName)
          }

          this.recutValueTableData = {
            nameTitle: 'Recut',
            valueTitle: 'Value',
            data: recutIssueList.map(issueInfo => {
              return {
                name: issueInfo.labelName,
                value: issueInfo.panelCount,
                displayValue: Utils.formatInteger(issueInfo.panelCount)
              }
            })
          }

          this.recutValueTableData.data = _.sortBy(this.recutValueTableData.data, 'value').reverse()
        }
      })
    }
  }
}


</script>